(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sol-fixes"] && !Shopify.designMode) return;
  try {
    (function () {
    var isHome = window.SOL_PAGE.isHome;
    var isProduct = window.SOL_PAGE.isProduct;
    var isGiftCard = window.SOL_PAGE.isGiftCard;
    var past = false;
    var chatRequested = false;

    /* ---- 4a. chat bubble gate. the widget lives in a shadow root that resets every
       inherited style, so it is parked inside a hidden wrapper instead of styled ---- */
    function chatGate() {
      var root = document.getElementById('raiforgex-chatbot-root');
      if (!root) return false;
      var gate = document.getElementById('sol-chat-gate');
      if (!gate) {
        gate = document.createElement('div');
        gate.id = 'sol-chat-gate';
        document.body.appendChild(gate);
      }
      if (root.parentNode !== gate) gate.appendChild(root);
      gate.classList.toggle('sol-chat-hidden', !chatRequested);
      if (!chatRequested && !document.getElementById('sol-open-chat')) {
        var launch=document.createElement('button');launch.id='sol-open-chat';launch.type='button';launch.textContent='Chat with SOL';launch.setAttribute('aria-label','Open SOL customer support chat');launch.style.cssText='position:fixed;bottom:20px;right:20px;z-index:55;background:#111;color:#fff;border:1px solid #fff;border-radius:24px;padding:12px 18px;font:inherit;font-size:14px;cursor:pointer;box-shadow:0 2px 10px #0002';
        launch.addEventListener('click',function(){chatRequested=true;gate.classList.remove('sol-chat-hidden');launch.remove();});document.body.appendChild(launch);
      }
      return true;
    }

    /* ---- 4b. stagger the popups ---- */
    function heroGate() {
      var trigger = isHome ? window.innerHeight * 0.9 : 300;
      function check() {
        if (!past && window.scrollY > trigger) {
          past = true;
          document.body.classList.add('sol-past-hero');
          chatGate();
          window.removeEventListener('scroll', check);
        }
      }
      window.addEventListener('scroll', check, { passive: true });
      check();
    }

    /* the site feedback card and the review popup share a corner, so never run both */
    function watchFeedback() {
      var fb = document.getElementById('sol-feedback');
      if (!fb) return;
      var sync = function () {
        document.body.classList.toggle('sol-feedback-open', !fb.hidden);
      };
      new MutationObserver(sync).observe(fb, { attributes: true, attributeFilter: ['hidden'] });
      sync();
    }

    /* ---- 5. announcement bar to newsletter ---- */
    function announcementLink() {
      var bar = document.querySelector('[class*="announcement"]');
      if (!bar) return;
      if (bar.textContent.indexOf('LIST') === -1) return;
      bar.classList.add('sol-announcement-clickable');
      bar.addEventListener('click', function (e) {
        if (e.target.closest('a, select, button')) return;
        var input = document.querySelector('footer input[type="email"], .footer input[type="email"]');
        if (!input) return;
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { input.focus(); }, 500);
      });
    }

    /* ---- 6. product page truth ---- */
    function currentVariantId() {
      var url = new URL(window.location.href);
      var fromUrl = url.searchParams.get('variant');
      if (fromUrl) return fromUrl;
      var input = document.querySelector('#MainContent form[action*="/cart/add"] [name="id"]');
      return input ? input.value : null;
    }

    /* ---- 9. open on a size we actually hold ----
       Shopify treats every variant as available while the product continues selling when out of
       stock, so the page would otherwise load on variant one whether or not it is in the room.
       If the visitor did not name a variant and the one that loaded is made to order, switch to
       the first variant with real stock. Respects deep links and pre-drop pieces. */
    var preselectDone = false;
    function preselectInStock() {
      if (preselectDone || !isProduct || isGiftCard) return;
      if (!window.SOL_FIRST_IN_STOCK || !window.SOL_VARIANT_OPTIONS || window.SOL_INCOMING) return;
      if (new URL(window.location.href).searchParams.get('variant')) { preselectDone = true; return; }
      var cur = currentVariantId();
      if (!cur) return;
      if (window.SOL_STOCK && window.SOL_STOCK[cur] === 1) { preselectDone = true; return; }
      var opts = window.SOL_VARIANT_OPTIONS[window.SOL_FIRST_IN_STOCK];
      if (!opts) { preselectDone = true; return; }
      var moved = false;
      for (var i = 0; i < opts.length; i++) {
        var val = opts[i];
        if (val === null || val === '') continue;
        var list = document.querySelectorAll('#MainContent input[type="radio"][name="option-' + (i + 1) + '"]');
        for (var j = 0; j < list.length; j++) {
          if (list[j].value === val && !list[j].checked) {
            list[j].checked = true;
            list[j].dispatchEvent(new Event('change', { bubbles: true }));
            moved = true;
          }
        }
      }
      if (moved) preselectDone = true;
    }

    function availabilityLine() {
      if (!isProduct || !window.SOL_STOCK) return;
      var host = document.querySelector('#MainContent .product-media-info-inner');
      if (!host) return;
      var anchor = host.querySelector('[data-main-price]');
      var el = document.getElementById('sol-avail');
      if (!el) {
        el = document.createElement('div');
        el.id = 'sol-avail';
        el.className = 'sol-avail';
        if (anchor && anchor.nextSibling) {
          anchor.parentNode.insertBefore(el, anchor.nextSibling);
        } else {
          host.appendChild(el);
        }
      }
      if (isGiftCard) {
        el.style.display = '';
        el.innerHTML = '<b>Digital gift card.</b> Delivered by email. No expiry or fees. Gift cards are final sale.';
        return;
      }
      /* a pre-drop piece is not sold out and not made to order yet, sol-drop-state owns the copy */
      if (window.SOL_INCOMING) return;
      var id = currentVariantId();
      var inStock = id && window.SOL_STOCK[id] === 1;
      /* the preorder app already spells out the made to order timing, so do not say it twice */
      var preorderBanner = document.querySelector('.restock-rocket-preorder-description');

      el.style.display = '';
      var message = inStock
        ? '<b>In stock.</b> Dispatch in 2–5 business days, then 2–5 business days US transit.'
        : '<b>Made to order.</b> 14–21 days production, then 2–5 business days US transit.<br><span>Preorder saves 5%, applied in your bag. One payment in full at checkout; no repeat deliveries.</span>';
      if (el.innerHTML !== message) el.innerHTML = message;
      var preorderPlan=window.SOL_PREORDER_PLANS && window.SOL_PREORDER_PLANS[id];
      host.querySelectorAll('button[data-addtocart-main] [data-addtocart-text]').forEach(function(label){
        if(!label.dataset.solDefaultLabel)label.dataset.solDefaultLabel=label.textContent.trim();
        var text=!inStock && preorderPlan?'Preorder · save 5%':label.dataset.solDefaultLabel;
        if(label.textContent.trim()!==text)label.textContent=text;
      });
    }

    function syncPreorderForm(form) {
      if(!isProduct || isGiftCard || window.SOL_INCOMING || !form || !form.id.startsWith('product-form-') || form.id.includes('installment')) return;
      var id=currentVariantId(), plan=window.SOL_PREORDER_PLANS && window.SOL_PREORDER_PLANS[id];
      var preorder=window.SOL_STOCK && window.SOL_STOCK[id]===0 && !!plan;
      var owned=form.querySelectorAll('[data-sol-preorder-fallback]');
      if(!preorder){owned.forEach(function(input){input.remove();});return;}
      var field=form.querySelector('input[name="selling_plan"]');
      if(!field){field=document.createElement('input');field.type='hidden';field.name='selling_plan';field.setAttribute('data-sol-preorder-fallback','true');form.appendChild(field);}
      field.value=plan;
      var properties={'Made to order':'14–21 days production, then 2–5 business days US transit.','One-time full payment':'Paid once in full at checkout. No subscription or repeat deliveries.','Preorder':'Save 5%'};
      Object.keys(properties).forEach(function(key){var name='properties['+key+']';if(form.querySelector('input[name="'+name+'"]'))return;var input=document.createElement('input');input.type='hidden';input.name=name;input.value=properties[key];input.setAttribute('data-sol-preorder-fallback','true');form.appendChild(input);});
    }
    document.addEventListener('submit',function(event){syncPreorderForm(event.target);},true);
    document.addEventListener('click',function(event){var button=event.target.closest('button[data-addtocart-main]');if(button)syncPreorderForm(button.form);},true);

    function preorderCopy() {
      if (!isProduct || isGiftCard) return;
      var details = document.querySelectorAll('.preorder-detail-text');
      for (var i = 0; i < details.length; i++) {
        var t = details[i].textContent || '';
        if (t.indexOf('As soon as possible') > -1) {
          details[i].textContent = '14–21 days production, then 2–5 business days US transit';
        }
      }
      var widget = document.querySelector('.restock-rocket-payment-widget');
      if (widget && !widget.querySelector('.sol-note')) {
        var note = document.createElement('p');
        note.className = 'sol-note';
        note.textContent = 'Preorders are charged in full today and the 5% comes off automatically at checkout. Nothing is charged again later.';
        widget.appendChild(note);
      }
    }

    function boot() {
      heroGate();
      watchFeedback();
      announcementLink();
      document.querySelectorAll('variant-selector fieldset, variant-selector .product-option').forEach(function (group) {
        var labels = Array.from(group.querySelectorAll('label'));
        var order = ['XXS','XS','S','M','L','XL','2XL','XXL','3XL','XXXL','4XL'];
        if (labels.length < 2 || !labels.every(function(l){return order.indexOf(l.textContent.trim()) >= 0;})) return;
        var items = labels.map(function(l){return l.closest('li');});
        if (items.some(function(l){return !l;}) || !items.every(function(l){return l.parentNode === items[0].parentNode;})) return;
        items.sort(function(a,b){return order.indexOf(a.querySelector('label').textContent.trim())-order.indexOf(b.querySelector('label').textContent.trim());}).forEach(function(item){item.parentNode.appendChild(item);});
      });
      preselectInStock();
      availabilityLine();
      preorderCopy();
      if (isProduct && !isGiftCard) {
        var productRoot = document.getElementById('MainContent');
        if (productRoot) {
          var preorderUpdate;
          new MutationObserver(function () {
            clearTimeout(preorderUpdate);
            preorderUpdate = setTimeout(preorderCopy, 100);
          }).observe(productRoot, { childList: true, subtree: true });
        }
      }

      /* the chat app injects itself late and can re-append itself to the body */
      var chatTries = 0;
      var chatTimer = setInterval(function () {
        chatGate();
        if (++chatTries > 40) clearInterval(chatTimer);
      }, 500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    /* apps and variant swaps rewrite the page after load, so keep checking for a while */
    if (isProduct) {
      document.addEventListener('change', function () { setTimeout(availabilityLine, 60); });
      document.addEventListener('click', function () { setTimeout(availabilityLine, 260); });
      var tries = 0;
      var timer = setInterval(function () {
        preselectInStock();
        preorderCopy();
        availabilityLine();
        if (++tries > 20) clearInterval(timer);
      }, 700);
    }
  })();


  (function () {
    function solPatchVariantSelector() {
      var C = customElements.get('variant-selector');
      if (!C || C.prototype.__solIdGuard) return;
      C.prototype.__solIdGuard = true;
      C.prototype.updateVariantInput = function () {
        var v = this.currentVariant;
        if (!v) return;
        var forms = document.querySelectorAll(
          '#product-form-' + this.dataset.section + ', #product-form-installment-' + this.dataset.section
        );
        forms.forEach(function (f) {
          var input = f.querySelector('input[name="id"]');
          if (!input) return; /* preorder app removed it from this form */
          input.value = v.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      };
    }
    if (window.customElements) {
      solPatchVariantSelector();
      if (customElements.whenDefined) {
        customElements.whenDefined('variant-selector').then(solPatchVariantSelector).catch(function () {});
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
